import styled from "styled-components";

export const Summary = styled.summary`

    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 22px;

`;

export const Answer = styled.p`

    margin: 10px;
    display: flex;
    justify-content: center;
    font-size: 18px;

`;

export const Details = styled.details`

    background-color: #fa821f;     
    width: 90%;
    padding: 20px 10px;
    border-radius: 10px;
    color: white;
    margin: 20px auto;

`;